import { getLoadingSelector } from 'app/store/app.selectors';
import { useSelector } from 'react-redux';

export const useSelectGlobalLoading = () => {
  return useSelector<unknown, boolean>(getLoadingSelector);
};
